import {Helmet} from '@dr.pogodin/react-helmet';
import {Box, getSize, Grid, GridItem, Show, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

type SourcingLayoutProps = {
  header: ReactNode;
  content: ReactNode;
  iframe?: ReactNode;
  pageTitle?: string;
  noResultsContent?: ReactNode;
};

export function SourcingLayout(props: SourcingLayoutProps) {
  const documentTitle = props.pageTitle || i18n.t('page.sourcing.labels.sourcing');

  return (
    <>
      <Helmet title={documentTitle} />
      <Box height={`calc(100vh - ${getSize(12)})`} overflow="hidden">
        {props.noResultsContent ?? (
          <Grid columns={[1, 1, 1, isNotNil(props.iframe) ? 3 : 2]} spacing={0} minHeight="100%">
            <GridItem span={[1, 1, 1, 2]}>
              <Box height={`calc(100vh - ${getSize(21)})`} padding={4}>
                <VStack spacing={4} height={`calc(100vh - ${getSize(21)})`}>
                  <Box flexShrink={0}>{props.header}</Box>
                  {props.content}
                </VStack>
              </Box>
            </GridItem>
            <Show onDesktop when={isNotNil(props.iframe)}>
              {props.iframe}
            </Show>
          </Grid>
        )}
      </Box>
    </>
  );
}
